import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {usePaymentPaypalContext} from '../../contexts/PaymentPaypalContext';
import styles from './ButtonSubmitPaypal.module.scss';

const ButtonSubmitPaypal = () => {
  const {loading} = usePaymentPaypalContext();

  return (
    <div className={styles.buttonSubmitContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'payment-form-submitBtn'}
            defaultMessage={'Create link'}
          />
        )}
        customClassnames={{container: styles.button}}
        disabled={loading}
      />
    </div>
  );
};

export default ButtonSubmitPaypal;
